// src/App.js
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, useTheme } from "./context/ThemeContext";

import HomePage from "./pages/HomePage";
import Register from "./pages/Register";
import MainDashboard from "./pages/MainDashboard";
import CameraDetail from "./pages/CameraDetail";

function AppContent() {
  const { theme } = useTheme();
  
  useEffect(() => {
    document.body.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<MainDashboard />} />
        <Route path="/camera/:id" element={<CameraDetail />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}
